import { CONVERSATION_BOX } from '../elements/conversationBox'
import { IMAGE_DESKTOP, IMAGE_MOBILE, ASSET_DESKTOP, ASSET_MOBILE } from '../elements/assets' 
import { BUTTON, BUTTON_SETTINGS } from '../elements/link'

export const HERO_CAROUSEL = `
...on heroCarousel_Entry {
  id
  typeHandle
  
  heading {
    html
  }

  headingTable {
    ... on headingTable_TableRow {
      col1
    }
  }

  description

  ${ BUTTON }
  ${ BUTTON_SETTINGS }

  heroCarouselSlides {
    ... on heroCarouselSlide_Entry {
      ${ CONVERSATION_BOX }
      id
      title

      thumbnail {
        url
        title
        width
        height
      }

      ${ IMAGE_MOBILE }

      ${ IMAGE_DESKTOP }

      ${ ASSET_MOBILE }

      ${ ASSET_DESKTOP }

      visualType
      lottieFileDesktop {
        url
      }

      lottieFileMobile {
        url
      }
        
    }
  }
}
`